<template>
  <div>
    
      <!-- PS Cards -->
    <div class="ps-cards">
      <div class="container">
        <div class="row">


          <div class="col-lg-4 col-sm-6">
            <div class="ps-card">
              <div class="ps-card-view">
                <img v-if="row.image6" :src="row.image6" class="img-fluid" :alt="row.title6" />
              </div>
              <div class="ps-card-details">
                <div class="title mb-1"
                    v-html="row.title6"
                    :style="'color:'+row.titleColor6+' !important'">
                </div>
                <div class="text mb-2"
                    v-html="row.content6"
                    :style="'color:'+row.contentColor6+' !important'">
                </div>
                <router-link v-if="row.button6" :to="row.redirect6"
                    class="ps-btn">{{ row.button6 }}
                </router-link>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-sm-6">
            <div class="ps-card">
              <div class="ps-card-view">
                <img v-if="row.image7" :src="row.image7" class="img-fluid" :alt="row.title7" />
              </div>
              <div class="ps-card-details">
                <div class="title mb-1"
                    v-html="row.title7"
                    :style="'color:'+row.titleColor7+' !important'">
                </div>
                <div class="text mb-2"
                    v-html="row.content7"
                    :style="'color:'+row.contentColor7+' !important'">
                </div>
                <router-link v-if="row.button7" :to="row.redirect7"
                    class="ps-btn">{{ row.button7 }}
                </router-link>
              </div>
            </div>
          </div>

          
          <div class="col-lg-4 col-sm-6">
            <div class="ps-card">
              <div class="ps-card-view">
                <img v-if="row.image8" :src="row.image8" class="img-fluid" :alt="row.title8" />
              </div>
              <div class="ps-card-details">
                <div class="title mb-1"
                    v-html="row.title8"
                    :style="'color:'+row.titleColor8+' !important'">
                </div>
                <div class="text mb-2"
                    v-html="row.content8"
                    :style="'color:'+row.contentColor8+' !important'">
                </div>
                <router-link v-if="row.button8" :to="row.redirect8"
                    class="ps-btn">{{ row.button8 }}
                </router-link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- PS Cards -->

  </div>
</template>

<script>
export default {
  name: "Section3",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
